import React from "react";
import { DA_Icon, DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { ReceiptProps } from "./Receipt.interface";
import S from "./Receipt.module.scss";

export const Receipt = (props: ReceiptProps) => {
    return (
        <div className={S.receiptWrapper}>
            <div className={S.inner}>
                <DA_Icon name={DA_IconNames.Checkmark} className={S.icon} />
                <DA_Title h4 noMargin fullWidth>
                    {props.receiptHeadline}
                </DA_Title>
                <DA_Text html={props.receiptText} />
            </div>
        </div>
    );
};
